import {
	pricingEstimateOptOutAtom,
	shouldUsePersonalizedQuoteAtom,
} from '@client/jotai/storefront/pricing';
import { useStorefrontPriceEstimator } from '@feature-flags/hooks/Storefront/useStorefrontPriceEstimator';
import { useAtomValue } from 'jotai';

export const useIsPriceEstimatorEnabled = useStorefrontPriceEstimator;

/**
 * True when the storefront has opted out of pricing estimates
 * (`vendorBehavior.pricingEstimateOptOut === true`). The atom is SSR-hydrated
 * from the storefront GraphQL fragment in `setVenuePricing`. The Search API
 * contract guarantees the field is a real boolean; the SSR-side `?? false`
 * guard is a defensive belt-and-suspenders during the mixed-version rollout
 * window and is a no-op once the API mapping is fully deployed.
 *
 * This is a content flag, not an experiment — it gates rendering only, not
 * Flipper assignment or analytics reporting.
 */
export const useIsStorefrontOptedOutOfPricingEstimates = () => {
	return useAtomValue(pricingEstimateOptOutAtom);
};

export const useShouldUsePersonalizedQuote = () => {
	return useAtomValue(shouldUsePersonalizedQuoteAtom);
};
